"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _resolveArrayValues = require("../utils/resolveArrayValues");

var _PIMProduct = _interopRequireDefault(require("./PIMProduct"));

var _PIMStyle = _interopRequireDefault(require("./PIMStyle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DATA_KEY_PRODUCTS = 'products';
var DATA_KEY_PRODUCTS_ALT = 'Products';
var DATA_KEY_PRODUCT = 'product';
var DATA_KEY_PRODUCT_ALT = 'ProductDetails';
var DATA_KEY_BRAND = 'brand';
var DATA_KEY_BRAND_ALT = 'Brand';
var DATA_KEY_RELATED_ACCESSORIES = 'relatedAccessories';
var DATA_KEY_RELATED_ACCESSORIES_ALT = 'RelatedAccessories';
var DATA_KEY_ACCESSORIES = 'accessories';
var DATA_KEY_ACCESSORIES_ALT = 'Accessories';
var DATA_KEY_STYLES = 'styles';
var DATA_KEY_STYLES_ALT = 'Styles';

if (Number.parseFloat === undefined) {
  Number.parseFloat = parseFloat;
}

var PIMData = /*#__PURE__*/function () {
  /**
   * @type {PIMProduct[]}
   * @property products
   * @private
   */

  /**
  * @type {PIMStyle[]}
  * @property styles
  * @private
  */

  /**
   * @type {object}
   * @property brandInfo
   * @private
   */

  /**
   * @param {object} data
   * @param {Error} error
   * @constructor
   * @example
   * import { PIMData } from '@demant/pim';
   */
  function PIMData(data, error, directPimProducts) {
    var _this = this;

    _classCallCheck(this, PIMData);

    /**
     * @type {Error}
     * @private
     */
    this.error = !directPimProducts ? error : null; // cached products

    /**
     * @type {Array}
     * @private
     */

    this.directPimProducts = directPimProducts ? directPimProducts : null; // get products from pim 

    /**
     * @type {Array}
     * @private
     */

    this.products = this.directPimProducts ? this.directPimProducts : [];

    if (data) {
      this.parseData(data);
    }
    /**
     * @type {Object.<string,PIMDataFilter>}
     * @private
     */


    this.filters = this.parseFiltersFromQuery();
    /**
     * @type {boolean}
     */

    this.hasFilters = function () {
      var _hasFilters = false;
      Object.keys(_this.filters).forEach(function (filterKey) {
        var filter = _this.filters[filterKey];

        if (filter.values.length) {
          _hasFilters = true;
        }
      });
      return _hasFilters;
    };

    this.useDeeplinkFilterQueries = true;
  }

  _createClass(PIMData, [{
    key: "setUseDeeplinkFilterQueries",
    value: function setUseDeeplinkFilterQueries(value) {
      this.useDeeplinkFilterQueries = value;
    }
    /**
     * @returns {boolean}
     */

  }, {
    key: "hasError",
    value: function hasError() {
      return !!this.error;
    }
    /**
     * @returns {Error|null}
     */

  }, {
    key: "getError",
    value: function getError() {
      return this.error;
    }
    /**
     * @returns {PIMProduct[]}
     */

  }, {
    key: "getProducts",
    value: function getProducts() {
      return this.filteredProducts() || [];
    }
    /**
     * @returns {Object.<string,PIMDataFilter>}
     */

  }, {
    key: "getFilters",
    value: function getFilters() {
      return this.filters || {};
    }
    /**
     * @returns {PIMStyle[]}
     */

  }, {
    key: "getStyles",
    value: function getStyles() {
      return this.styles || [];
    }
    /**
     * @param {string} key
     * @returns {string}
     */

  }, {
    key: "getBrandInfo",
    value: function getBrandInfo(key) {
      var value = this.brandInfo && (this.brandInfo[key] || this.brandInfo["".concat(key[0].toLowerCase()).concat(key.slice(1))]);
      return value || key;
    }
    /**
     *
     * @param {string} key
     * @param {boolean} isInclusive
     */

  }, {
    key: "createFilter",
    value: function createFilter(key) {
      var _this2 = this;

      var isInclusive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var filterValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      if (key.toLowerCase() !== key && this.filters[key.toLowerCase()]) {
        this.filters[key] = _objectSpread({}, this.filters[key.toLowerCase()]);
        filterValues.forEach(function (filterValue) {
          _this2.filters[key].values.forEach(function (filterValueSet, index) {
            if (filterValue.value.toLowerCase() === filterValueSet) {
              _this2.filters[key].values[index] = filterValue.value;
              filterValue.isSelected = true;
            }
          });
        });
        delete this.filters[key.toLowerCase()];
      }

      if (!this.filters[key]) {
        this.filters[key] = {
          isInclusive: isInclusive,
          values: []
        };
      }

      this.filters[key].isInclusive = isInclusive;
    }
    /**
     *
     * @param {string} key
     * @param {string|boolean|number} value
     * @param {string|null} value
     */

  }, {
    key: "setFilter",
    value: function setFilter(key, value, label) {
      if (!this.filters[key]) {
        this.createFilter(key);
      }

      this.filters[key].label = label;
      this.hasFilters = true;

      if (this.filters[key].values.indexOf(value) === -1) {
        this.filters[key].values.push(value);
      }

      this.buildFilterQuery();
    }
  }, {
    key: "unsetFilter",
    value: function unsetFilter(key, value) {
      if (this.filters[key]) {
        this.filters[key].values = this.filters[key].values.filter(function (_value) {
          return _value !== value;
        });
      }

      this.buildFilterQuery();
    }
  }, {
    key: "isSetFilter",
    value: function isSetFilter(key, value) {
      return this.filters[key] && this.filters[key].values && this.filters[key].values.indexOf(value) > -1;
    }
    /**
     * @param {string} key
     */

  }, {
    key: "resetFilter",
    value: function resetFilter(key) {
      var _this3 = this;

      if (this.filters[key]) {
        this.hasFilters = false;
        this.filters[key].values = [];
        Object.keys(this.filters).forEach(function (filterKey) {
          var filter = _this3.filters[filterKey];

          if (filter.values.length) {
            _this3.hasFilters = true;
          }
        });
        this.buildFilterQuery();
      }
    }
  }, {
    key: "resetAllFilters",
    value: function resetAllFilters() {
      var _this4 = this;

      Object.keys(this.filters).forEach(function (filterKey) {
        _this4.filters[filterKey].value = [];
      });
      this.hasFilters = false;
      this.buildFilterQuery();
    }
    /**
     * @private
     */

  }, {
    key: "buildFilterQuery",
    value: function buildFilterQuery() {
      var _this5 = this;

      if (!window.location) return;
      if (!this.useDeeplinkFilterQueries) return;

      if (history.replaceState && !document.querySelector('.component.pep-product-details')) {
        var filterQueries = [];
        Object.keys(this.filters).forEach(function (filterKey) {
          var filterQuery = filterKey;

          if (_this5.filters[filterKey].values.length) {
            _this5.filters[filterKey].values.forEach(function (filterValue) {
              var filterValueAsString = filterValue.toString();
              filterQuery = "".concat(filterQuery, ":").concat(filterValueAsString.split(' ').join('_'));
            });

            filterQueries.push(filterQuery);
          }
        });
        var newurl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname).concat(filterQueries.length ? "?filters=".concat(filterQueries.join(';')) : '');
        window.history.pushState({}, document.title, newurl);
      }
    }
    /**
     * @private
     */

  }, {
    key: "parseFiltersFromQuery",
    value: function parseFiltersFromQuery() {
      if (!window.location) return {};
      var regex = new RegExp('[\\?&]filters=([^&#]*)');
      var results = regex.exec(window.location.search);
      var filterQuery = results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      var filters = filterQuery.split(';');
      var parsedFilters = {};
      filters.forEach(function (filter) {
        var _filter$split = filter.split(':'),
            _filter$split2 = _toArray(_filter$split),
            filterKey = _filter$split2[0],
            filterValues = _filter$split2.slice(1);

        parsedFilters[filterKey] = {
          values: filterValues.map(function (value) {
            return value.split('_').join(' ');
          })
        };
      });
      return parsedFilters;
    }
    /**
     *
     * @param {object} data
     * @private
     */

  }, {
    key: "parseData",
    value: function parseData(data) {
      this.parseProducts(data);
      this.parseStyles(data);
      this.parseBrandInfo(data);
    }
    /**
     * @param {object} data
     * @private
     */

  }, {
    key: "parseProducts",
    value: function parseProducts(data) {
      var _this6 = this;

      var productCollectionKeys = [DATA_KEY_ACCESSORIES, DATA_KEY_ACCESSORIES_ALT, DATA_KEY_PRODUCTS, DATA_KEY_PRODUCTS_ALT];
      var relatedAccesoryCollectionKeys = [DATA_KEY_RELATED_ACCESSORIES, DATA_KEY_RELATED_ACCESSORIES_ALT];
      var productKeys = [DATA_KEY_PRODUCT, DATA_KEY_PRODUCT_ALT];
      var isSingleProduct = false; // Look for single product

      productKeys.forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          var productData = data[key];

          if (!_this6.directPimProducts && productData && _typeof(productData) === 'object') {
            _this6.products.push(new _PIMProduct["default"](productData));

            isSingleProduct = true;
          }
        }
      });

      if (!isSingleProduct) {
        // Look for product list
        productCollectionKeys.forEach(function (collectionKey) {
          if (Object.prototype.hasOwnProperty.call(data, collectionKey)) {
            var products = data[collectionKey];

            if (!_this6.directPimProducts && products && Array.isArray(products)) {
              products.forEach(function (productData) {
                _this6.products.push(new _PIMProduct["default"](productData));
              });
            }
          }
        });
      }

      if (isSingleProduct || this.products.length === 0) {
        // Look for related accessories
        relatedAccesoryCollectionKeys.forEach(function (collectionKey) {
          if (Object.prototype.hasOwnProperty.call(data, collectionKey)) {
            var products = data[collectionKey];

            if (products && Array.isArray(products)) {
              products.forEach(function (productData) {
                var accessory = new _PIMProduct["default"](productData);

                if (isSingleProduct) {
                  // Add related accessories directly to product
                  _this6.products[0].relatedAccessories.push(accessory);
                } else {
                  // Add related accessories to product list
                  _this6.products.push(accessory);
                }
              });
            }
          }
        });
      }
    }
  }, {
    key: "parseStyles",
    value: function parseStyles(data) {
      var _this7 = this;

      this.styles = [];
      var styleKeys = [DATA_KEY_STYLES, DATA_KEY_STYLES_ALT];
      styleKeys.forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          var styles = data[key];

          if (styles && Array.isArray(styles)) {
            styles.forEach(function (styleData) {
              _this7.styles.push(new _PIMStyle["default"](styleData));
            });
          }
        }
      });
    }
    /**
     * @param {object} data
     * @private
     */

  }, {
    key: "parseBrandInfo",
    value: function parseBrandInfo(data) {
      var _this8 = this;

      this.brandInfo = this.brandInfo || {};
      var brandKeys = [DATA_KEY_BRAND, DATA_KEY_BRAND_ALT];
      brandKeys.forEach(function (key) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          var brand = data[key];
          Object.keys(brand).forEach(function (bKey) {
            _this8.brandInfo["".concat(bKey.substr(0, 1).toLowerCase()).concat(bKey.substr(1))] = brand[bKey];
          });
        }
      });
    }
    /**
     * @returns {PIMProduct[]}
     * @private
     */

  }, {
    key: "filteredProducts",
    value: function filteredProducts() {
      var _this9 = this;

      if (!this.products) return null;
      if (!this.hasFilters) return this.products;
      var filtered = [];
      var filterKeys = Object.keys(this.filters);
      var numFilters = filterKeys.length;
      this.products.forEach(function (product) {
        var productMatch = 0;
        filterKeys.forEach(function (filterKey) {
          productMatch += _this9.getProductMatchForFilter(product, filterKey);
        });

        if (productMatch === numFilters) {
          filtered.push(product);
        }
      });
      return filtered;
    }
  }, {
    key: "getNumberOfProductsForFilter",
    value: function getNumberOfProductsForFilter(filterKey, filterValue) {
      var _this10 = this;

      if (!this.products) return 0;
      var filtered = [];
      this.products.forEach(function (product) {
        var productMatch = _this10.getProductMatchForFilterAndValue(product, filterKey, filterValue);

        if (productMatch > 0) {
          filtered.push(product);
        }
      });
      return filtered.length;
    }
  }, {
    key: "getProductMatchForFilterAndValue",
    value: function getProductMatchForFilterAndValue(product, filterKey, value) {
      var _this11 = this;

      var valueArr = value ? (0, _resolveArrayValues.resolveArrayValues)(value) : value;
      var filterMatch = 0;
      var doesMatchFilter = false;
      value && valueArr.forEach(function (filterValue) {
        if (!doesMatchFilter) {
          var filterMatches = _this11.filterMatches(product, filterKey, filterValue);

          if (filterMatches > 0) {
            doesMatchFilter = true;
          }

          filterMatch += filterMatches;
        }
      });
      return filterMatch;
    }
  }, {
    key: "getProductMatchForFilter",
    value: function getProductMatchForFilter(product, filterKey) {
      var _this12 = this;

      var filter = this.filters[filterKey];
      var productMatch = 0;
      var filterMatch = 0;
      filter.values.forEach(function (value) {
        filterMatch += _this12.getProductMatchForFilterAndValue(product, filterKey, value);
      });

      if (filter.values.length === 0 || filterMatch > 0 && (filter.isInclusive || filterMatch === filter.values.length)) {
        productMatch += 1;
      }

      return productMatch;
    }
  }, {
    key: "filterMatches",
    value: function filterMatches(product, filterKey, value) {
      var _this13 = this;

      var productValue = product[filterKey];
      var filterMatch = 0;

      if (productValue !== null) {
        if (Array.isArray(productValue)) {
          productValue.forEach(function (productValueItem) {
            if (_this13.filterMatch(value, productValueItem)) {
              filterMatch += 1;
            }
          });
        } else if (this.filterMatch(value, productValue)) {
          filterMatch += 1;
        }
      }

      return filterMatch;
    }
    /**
     * @param {string|boolean|number} searchValue
     * @param {string|boolean|number} productValue
     * @returns {boolean}
     */

  }, {
    key: "filterMatch",
    value: function filterMatch(searchValue, productValue) {
      if (typeof productValue === 'boolean') {
        var boolSearchValue = searchValue === 'false' || searchValue === '0' ? false : !!searchValue;
        return !!boolSearchValue === productValue;
      }

      if (typeof productValue === 'number') {
        return Number.parseFloat(searchValue) === productValue;
      }

      if (typeof productValue === 'string') {
        var isValueMatched = searchValue.indexOf(',') > -1 ? searchValue.includes(productValue) : searchValue.toLowerCase() === productValue.toLowerCase();
        return isValueMatched;
      }

      return searchValue === productValue;
    }
  }]);

  return PIMData;
}();

var _default = PIMData;
/**
 * @typedef PIMDataFilter
 * @property {boolean} isInclusive
 * @property {Array.<string|boolean|number>} values
 * */

exports["default"] = _default;